import { createAction, props } from '@ngrx/store';

export const chatUserDisconnected = createAction('[Stream Chat] (User) Disconnected');
export const chatUserDisconnectionFailed = createAction(
  '[Stream Chat] (User) Disconnection Failed',
  props<{ error: any }>(),
);

export const chatChannelsReset = createAction('[Stream Chat] (Channels) Reset');
